import { useEffect, useState } from "react";
import { useApiClient } from "../../../../shared/hooks";
import { createCumulativeData } from "../utils/createCumulativeData";

function useLineOfTotalRegisteredUsers(startDate: string, endDate?: string) {
  const apiClient = useApiClient();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        const data = await apiClient.getUserAnalyticsData(startDate, endDate);
        setUserData(data);
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate]);

  if (!userData) {
    return {
      data: null,
      isLoading,
      isError,
    };
  }

  // Check if the response is aggregated by looking at the structure of the first item in created_at_dates
  const isAggregated = userData.created_at_dates.length > 0 && typeof userData.created_at_dates[0] === 'object';

  const data = createCumulativeData(
    userData.created_at_dates,
    userData.count_before_start_date,
    isAggregated
  );

  return {
    data,
    isLoading,
    isError,
  };
}

export default useLineOfTotalRegisteredUsers;
